import React from 'react';

import { Avatar, Text } from '@change/ds-core-ui/next';

import { useTracking } from '../../../hooks/useTracking';
import type { NormalizedDecisionMaker } from '../../../shared/types';
import { DecisionMakerResponse } from '../../shared/DecisionMakerResponse';
import { Name } from '../../shared/Name';
import { Signers } from '../../shared/Signers';
import { SignersTooltip } from '../../shared/SignersTooltip';

export const Member: React.FC<NormalizedDecisionMaker> = ({
	photoUrl,
	displayName,
	publiclyVisible,
	slug,
	id,
	title,
	constituentCount,
	constituentCountLocalized,
	isFormer,
	response,
}) => {
	const { trackDMMoreInfoClick } = useTracking();
	return (
		<div className="flex" data-qa="dm-card">
			<Avatar src={photoUrl || undefined} alt={displayName} size={32} className="mb-3 mr-3 flex-shrink-0" />
			<div className="flex flex-col md:items-start">
				<div className="mb-2">
					<div className="flex items-center gap-[6px]">
						<Name displayName={displayName} id={id} publiclyVisible={publiclyVisible} slug={slug} />
						{constituentCount > 0 && (
							<div className="lg:hidden">
								<SignersTooltip
									constituentCount={constituentCount}
									constituentCountLocalized={constituentCountLocalized}
									isFormer={isFormer}
									onTooltipClick={() => trackDMMoreInfoClick(id)}
								/>
							</div>
						)}
					</div>

					<div className="flex flex-wrap items-center gap-x-3 gap-y-2">
						<Text variant="body" className="text-muted text-sm">
							{title}
						</Text>

						{constituentCount > 0 && (
							<div className="hidden lg:inline-block">
								<Signers
									constituentCount={constituentCount}
									constituentCountLocalized={constituentCountLocalized}
									isFormer={isFormer}
								/>
							</div>
						)}
					</div>
				</div>

				{response && <DecisionMakerResponse response={response} />}
			</div>
		</div>
	);
};
